import React from "react"
import Details from "./Details"

// Both registered routes use the same target-aware editor, including on a cold load.
export default function PhaseDetails(props) {
  return <Details {...props} />
}
